<section
  class="left-side pt-5 lg:pr-5 lg:pl-5 w-full pb-6 flex flex-column"
  [style.max-height]="stepperHeight"
  [style.overflow-y]="'auto'"
>
  <section class="flex justify-content-between mb-5 align-items-center px-3 lg:px-0">
    <div>
      <h1 class="text-2xl mx-0 my-0 title">{{ 'adhoc.title' | translate }}</h1>
      <p class="mx-0 my-0 subtitle">{{ 'adhoc.subtitle' | translate }}</p>
    </div>
  </section>
  <section>
    <p-card>
      <ng-template pTemplate="content">
        <form [formGroup]="adhocForm">
          <h2>{{ 'adhoc.designator' | translate }}: {{ adhocName }}</h2>
          <p-divider></p-divider>
          <p-stepper [value]="activeStep + 1">
            <!-- STEP 1 -->
            <p-step-item [value]="1">
              <p-step>{{ 'adhoc.saveFormat' | translate }}</p-step>
              <p-step-panel>
                <ng-template #content let-activateCallback="activateCallback">
                  <div class="flex flex-wrap gap-3">
                    <div class="flex align-items-center">
                      <p-radioButton
                        name="format"
                        [value]="coordinatesFormat.DMS"
                        formControlName="format"
                        inputId="dms"
                        (onClick)="onCoordinatesFormatChange($event)"
                      ></p-radioButton>
                      <label for="dms" class="ml-2">{{ 'adhoc.ddmmssLabel' | translate }}</label>
                    </div>

                    <div class="flex align-items-center">
                      <p-radioButton
                        name="format"
                        [value]="coordinatesFormat.DECIMAL"
                        formControlName="format"
                        inputId="decimal"
                        (onClick)="onCoordinatesFormatChange($event)"
                      ></p-radioButton>
                      <label for="decimal" class="ml-2">{{ 'adhoc.decimalLabel' | translate }}</label>
                    </div>
                  </div>
                  <div class="flex py-4 justify-content-end">
                    <p-button
                      [label]="'buttons.next' | translate"
                      (onClick)="nextStep(); activateCallback(2)"
                      icon="pi pi-chevron-right"
                      iconPos="right"
                    />
                  </div>
                </ng-template>
              </p-step-panel>
            </p-step-item>

            <!-- STEP 2 -->
            <p-step-item [value]="2">
              <p-step>{{ 'adhoc.coordinates' | translate }}</p-step>
              <p-step-panel>
                <ng-template #content let-activateCallback="activateCallback">
                  <div class="flex flex-column h-28rem">
                    <p-tabs [value]="activeTab.toString()" (onTabChange)="onTabChange($event.value)">
                      <p-tablist>
                        <p-tab value="0">{{ 'adhoc.circle' | translate }}</p-tab>
                        <p-tab value="1">{{ 'adhoc.polygon' | translate }}</p-tab>
                      </p-tablist>
                      <p-tabpanels>
                        <p-tabpanel value="0">
                          <rqa-add-circle
                            [circleForm]="adhocForm.controls['circle']"
                            [coordinatesFormat]="selectedCoordinatesFormat"
                            [resetForm]="resetForm"
                          ></rqa-add-circle>
                        </p-tabpanel>
                        <p-tabpanel value="1">
                          <rqa-add-poly
                            [polyForm]="adhocForm.controls['poly']"
                            [coordinatesFormat]="selectedCoordinatesFormat"
                            [resetForm]="resetForm"
                          ></rqa-add-poly>
                        </p-tabpanel>
                      </p-tabpanels>
                    </p-tabs>
                  </div>
                  <div class="flex py-4 gap-2 justify-content-end">
                    <p-button
                      [label]="'buttons.prev' | translate"
                      severity="secondary"
                      icon="pi pi-chevron-left"
                      (onClick)="prevStep(); activateCallback(1)"
                    />
                    <p-button
                      [label]="'buttons.next' | translate"
                      (onClick)="draw(); nextStep(); activateCallback(3)"
                      icon="pi pi-chevron-right"
                    />
                  </div>
                </ng-template>
              </p-step-panel>
            </p-step-item>

            <!-- STEP 3 -->
            <p-step-item [value]="3">
              <p-step>{{ 'adhoc.validityPeriod' | translate }}</p-step>
              <p-step-panel>
                <ng-template #content let-activateCallback="activateCallback">
                  <div class="flex flex-column h-18rem">
                    <div class="flex flex-column h-18rem">
                      <rqa-add-times [dateAndAltitudes]="adhocForm.controls['dateAndAltitudes']"></rqa-add-times>
                      <p-message [text]="validationMessage" [closable]="false" />
                    </div>
                  </div>
                  <div class="flex py-4 gap-2 justify-content-end">
                    <p-button
                      [label]="'buttons.prev' | translate"
                      severity="secondary"
                      icon="pi pi-chevron-left"
                      (onClick)="prevStep(); activateCallback(2)"
                    />
                    <p-button
                      [label]="'buttons.save' | translate"
                      (onClick)="createAdhoc()"
                      icon="pi pi-check"
                      [disabled]="!adhocForm.get('dateAndAltitudes').valid || !hasGeoJsonSignal()"
                    />
                  </div>
                </ng-template>
              </p-step-panel>
            </p-step-item>
          </p-stepper>
        </form>
      </ng-template>
    </p-card>
  </section>
</section>
